var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#70AD54",
    d: "M18 10c0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8 8-3.58 8-8M7.23 3.57 8.72 7.3c-.62.29-1.13.8-1.42 1.42L3.57 7.23a7.04 7.04 0 0 1 3.66-3.66m9.2 3.66L12.7 8.72c-.29-.62-.8-1.13-1.42-1.42l1.49-3.73c1.64.71 2.95 2.02 3.66 3.66M10 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m-6.43.77 3.73-1.49c.29.62.8 1.13 1.42 1.42l-1.49 3.73a7.04 7.04 0 0 1-3.66-3.66m9.2 3.66-1.49-3.73c.62-.29 1.13-.8 1.42-1.42l3.73 1.49a7.04 7.04 0 0 1-3.66 3.66",
    className: "icon_svg__black"
  })));
};
export default SvgIcon;